/**
 * Copyright 2016 xdot GmbH
 * Author: Carsten Hibbeler
 * Date: 23.02.2016
 */
import { AppContext, ReduceStore } from 'plugin/liferay-widgets-react-web';
import ActionsTypesModal from '../constants/ActionsTypesModal';

export default class ModalStore extends ReduceStore {

    constructor() {
        super(AppContext.getDispatcher());
    }

    getInitialState() {
        return {
            modals: []
        };
    }

    getModals() {
        return this._state.modals;
    }

    createModal(state, key, dataName, className, store, props, context) {
        let newModals = state.modals.slice();
        newModals.push({
            key,
            className,
            dataName,
            store,
            props,
            context
        });

        return {
            ...state,
            modals: newModals
        };
    }

    removeModal(state, key) {
        let newModals = state.modals.filter(modal => {
            return modal.key != key;
        });

        return {
            ...state,
            modals: newModals
        };
    }

    getModalByKey(state, key) {
        let m = undefined;
        if (state.modals && Array.isArray(state.modals)) {
            state.modals.forEach((modal) => {
                if (modal.key == key) {
                    m = modal;
                }
            });
        }
        return m;
    }

    getStore(dataName, className) {
        const remoteDataStores = AppContext.getStores()
            .filter(s => s.getRemoteData && s !== this)
            .filter(s => s.containsRemoteData && s.containsRemoteData(dataName, className));

        if (remoteDataStores.length > 0) {
            if (remoteDataStores.length > 1) {
                console.error('More than one store for dataName: ' + dataName + ' className: ' + className + ' found!');
            }
            return remoteDataStores[ 0 ];
        } else {
            console.error("No Store found for className: ", className)
        }
    }

    reduce(state, action) {

        switch (action.type) {

            case ActionsTypesModal.SHOW_MODAL: {
                let { dataName, className, props, context } = action.payload,
                    key = className + dataName,
                    store = this.getStore(dataName, className);

                this.getDispatcher().waitFor([ store.getDispatchToken() ]);

                if (!this.getModalByKey(state, key)) {
                    state = this.createModal(state, key, dataName, className, store, props, context);
                }

                break;
            }
            case ActionsTypesModal.HIDE_MODAL: {
                state = this.removeModal(state, action.payload.className + action.payload.dataName);
                break;
            }
        }

        return state;
    }


}



// WEBPACK FOOTER //
// ./js/stores/ModalStore.js